import type { Tenant } from "albertine-shared-web";
import { albertineProfileConfig } from "./albertine";
import { carloProfileConfig } from "./carlo";
import { hugobossProfileConfig } from "./hugoboss";
import { mastercardProfileConfig } from "./mastercard";
import { revolutProfileConfig } from "./revolut";
import type { ProfileConfig } from "./types";
import { visaI2ProfileConfig } from "./visa-i2";

export type { ProfileConfig } from "./types";

export const profileConfigs: Record<Tenant, ProfileConfig> = {
    albertine: albertineProfileConfig,
    hugoboss: hugobossProfileConfig,
    mastercard: mastercardProfileConfig,
    carlo: carloProfileConfig,
    "visa-i2": visaI2ProfileConfig,
    revolut: revolutProfileConfig,
};
